import { proxy } from "valtio";

export interface ReadItemState {
  readItemIds: Set<string>;
  markAsRead: (id: string) => void;
  clear: () => void;
}

/**
 * Session-level store for tracking which items the user has read.
 * Not persisted — refresh resets to server-provided read state.
 * Used for optimistic "read" UI updates (opacity-50, badge count).
 */
export const readItemStore = proxy<ReadItemState>({
  readItemIds: new Set<string>(),
  markAsRead(id: string) {
    this.readItemIds.add(id);
  },
  clear() {
    this.readItemIds.clear();
  },
});
